import React from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import MainProviders from './providers/MainProviders';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { createRoot } from 'react-dom/client';
import AuthProvider from './providers/AuthProvider';
import { HelmetProvider } from 'react-helmet-async';
import AuthenticatedApp from './hooks/useAuthenticatedApp';

const container = document.getElementById('root');
const root = createRoot(container as Element);
const helmetContext = {};

root.render(
  <AuthProvider>
    <MainProviders>
      <BrowserRouter>
        <HelmetProvider context={helmetContext}>
          <AuthenticatedApp helmetContext={helmetContext} />
        </HelmetProvider>
      </BrowserRouter>
    </MainProviders>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
